export const enum VerificationMethod {
  Veriff = 'veriff',
  Finapi = 'finapi',
}
